import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  mode: "light",
  user: null,
  token: null,
  refreshCount: 0,
  broker: {},
  manager: {},
  landlord: {},
  isAdmin: 0,
  managerDetails: {},
  /** Role from login: "admin" | "manager" | "relationship_manager" | "landlord" | "tenant" */
  role: null,
  /** Set when role === "relationship_manager" */
  relationshipManager: null,
  /** Set when role === "relationship_manager"; LandLordRental IDs assigned to this RM */
  assignedPropertyIds: [],
  property_id: null,
  tenantOccupancy: {},
  tenantPayment: {},
  years:[2024,2025,2026,2027,2028,2029,2030,2031,2032,2033,2034],
  currentTab: {
    settingsTab: 0,
    managementTab: 0,
    landlordsTab: 0,
    generalPropertiesTab: 0,
    generalLandlordsTab:0,
    propertyTab:0,
    systemLogsTab:0
  },
  /** Pre-fetched comprehensive reports (all) for Reports page; not persisted */
  reportsCache: {
    reportData: [],
    summary: null,
    isLoading: false,
    error: false,
    hasFetched: false,
  },
  /** Set when home dashboard critical API calls finish (so comprehensive can run after) */
  dashboardBootstrap: {
    dailySummaryReady: false,
    dashboardReady: false,
  },
};

export const manager_id = 1;

export const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    setMode: (state) => {
      state.mode = state.mode === "light" ? "dark" : "light";
    },
    setLogin: (state, action) => {
      state.user = action.payload.user;
      state.token = action.payload.token;
      state.isAdmin = action.payload.admin;
      state.role = action.payload.role ?? null;
      state.relationshipManager = action.payload.relationshipManager ?? null;
      state.assignedPropertyIds = action.payload.assignedPropertyIds ?? [];
      state.dashboardBootstrap = { dailySummaryReady: false, dashboardReady: false };
      state.reportsCache = { reportData: [], summary: null, isLoading: false, error: false, hasFetched: false };
    },
    setLogout: (state) => {
      state.user = null;
      state.token = null;
      state.isAdmin = null;
      state.role = null;
      state.relationshipManager = null;
      state.assignedPropertyIds = [];
      state.managerDetails = {};
      state.reportsCache = { reportData: [], summary: null, isLoading: false, error: false, hasFetched: false };
      state.dashboardBootstrap = { dailySummaryReady: false, dashboardReady: false };
      state.currentTab = {
        settingsTab: 0,
        managementTab: 0,
        landlordsTab: 0,
        generalPropertiesTab: 0,
        propertyTab:0,
        generalLandlordsTab:0,
        systemLogsTab:0
      }
    },
    setRefreshCount: (state, action) => {
      state.refreshCount = action.payload; // Added reducer for refresh count
    },
    setBroker: (state, action) => {
      state.broker = action.payload;
    },
    setManager: (state, action) => {
      state.manager = action.payload;
    },
    setLandlord: (state, action) => {
      state.landlord = action.payload;
    },
    setIsAdmin: (state, action) => {
      state.isAdmin = action.payload;
    },
    setManagerDetails: (state, action) => {
      state.managerDetails = action.payload;
    },
    setTenantOccupancy: (state, action) => {
      state.tenantOccupancy = action.payload;
    },
    setTenantPayment: (state, action) => {
      state.tenantPayment = action.payload;
    },
    setPropertyId: (state, action) => {
      state.property_id = action.payload
    },
    setCurrentTab: (state, action)=>{
      state.currentTab[action.payload.name] = action.payload.tab;
    },
    setReportsCacheLoading: (state, action) => {
      state.reportsCache.isLoading = action.payload;
    },
    setReportsCache: (state, action) => {
      state.reportsCache.reportData = action.payload.reportData ?? [];
      state.reportsCache.summary = action.payload.summary ?? null;
      state.reportsCache.isLoading = false;
      state.reportsCache.error = false;
      state.reportsCache.hasFetched = true;
    },
    setReportsCacheError: (state) => {
      state.reportsCache.isLoading = false;
      state.reportsCache.error = true;
      state.reportsCache.hasFetched = true;
    },
    setDashboardBootstrapReady: (state, action) => {
      const { dailySummary, dashboard } = action.payload;
      if (dailySummary !== undefined) state.dashboardBootstrap.dailySummaryReady = dailySummary;
      if (dashboard !== undefined) state.dashboardBootstrap.dashboardReady = dashboard;
    },
  },
});

export const {
  setMode,
  setLogin,
  setLogout,
  setRefreshCount,
  setBroker,
  setManager,
  setLandlord,
  setIsAdmin,
  setManagerDetails,
  setTenantOccupancy,
  setTenantPayment,
  setPropertyId,
  setCurrentTab,
  setReportsCacheLoading,
  setReportsCache,
  setReportsCacheError,
  setDashboardBootstrapReady,
} = authSlice.actions;
export default authSlice.reducer;
